<svg-icon [src]="iconPath"></svg-icon>
